// @ts-nocheck
import * as lensApi from '../api/lensApi';

export function getUserLens(id) {
  return lensApi.getUserLens(id);
}

export function getCompanyLens(id) {
  return lensApi.getCompanyLens(id);
}
